import { createContext, useContext } from 'react';
import { MetricDefinition, Metric } from '../types';

type MetricsContextState = {
  highLevelMetrics: Metric[];
  analyticsMetrics: Metric[];
  metricsLoading: boolean;
  analyticsMetricsValueTypes: Record<string, string>;
  highLevelMetricsValueTypes: Record<string, string>;
  analyticsMetricDefinitions: Record<string, MetricDefinition>;
  highLevelMetricDefinitions: Record<string, MetricDefinition>;
};

export const defaultMetricsContextState = {
  highLevelMetrics: [],
  analyticsMetrics: [],
  metricsLoading: false,
  analyticsMetricsValueTypes: {},
  highLevelMetricsValueTypes: {},
  analyticsMetricDefinitions: {},
  highLevelMetricDefinitions: {},
};

export const MetricsContext = createContext<MetricsContextState>(defaultMetricsContextState);

export const useMetricsContext = () => useContext(MetricsContext);
